import React from "react";
import { forwardRef } from "react";

import { 
  Gallery, 
  ProjectWrapper, 
  ProjectImage, 
  ProjectOverlay, 
  ArtProjectLink } from "../styled-components/projectListstyle";

const ArtProjectList = forwardRef(( { artprojects }, artprojectListRef)=> {

  return (
    <Gallery ref={artprojectListRef}>
      {artprojects.map((item, index) => (
        <ProjectWrapper key={index}>
          <ProjectImage 
            src={item.images[0]}
            alt={item.info}      
          />
          <ProjectOverlay>
          <ArtProjectLink to={`/artproject/${item.path}`}>
            {item.info.map((line, index) => (
              <React.Fragment key={index}>{line}<br /></React.Fragment>
            ))}
          </ArtProjectLink>
        </ProjectOverlay>
        </ProjectWrapper>
      ))}
    </Gallery>
  )
})

export default ArtProjectList;
